import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from "react-router";

import { BackupOtpPage } from "../pages/client/auth/backup-otp/page";
import { ForgotPasswordPage } from "../pages/client/auth/forgot-password/page";
import { AuthLayout } from "../pages/client/auth/layout";
import { LoginPage } from "../pages/client/auth/login/page";
import { RegisterPage } from "../pages/client/auth/register/page";
import { ResetPasswordPage } from "../pages/client/auth/reset-password/page";
import { VerifyEmailPage } from "../pages/client/auth/verify-email/page";
import { VerifyOtpPage } from "../pages/client/auth/verify-otp/page";
import { ActivatePage } from "../pages/client/auth/activate/page";
import { UnsubscribePage } from "../pages/public/unsubscribe/page";
import { BuilderLayout } from "../pages/client/builder/layout";
import { builderLoader, BuilderPage } from "../pages/client/builder/page";
import { UserSpaceNotificationsPage } from "../pages/client/user-space/notifications/page";
import { UserSpaceNotificationDetailPage } from "../pages/client/user-space/notifications/notification-detail";
import { UserSpaceHelpPage } from "../pages/client/user-space/help/help-page";
import { UserSpaceHelpRequestDetailPage } from "../pages/client/user-space/help/help-request-detail";
import { HomeLayout } from "../pages/home/layout";
import { HomePage } from "../pages/home/page";
import { ErrorPage } from "../pages/public/error";
import { Providers } from "../providers";
import { AuthGuard } from "./guards/auth";
import { GuestGuard } from "./guards/guest";
import { authLoader } from "./loaders/auth";
import { DashboardLayoutAmb } from "../pages/ambassador/dashboard/layout";
import { OverviewPage } from "../pages/ambassador/dashboard/overview/page";
import { TransactionsPage } from "../pages/ambassador/dashboard/transactions/page";
import { WithdrawalsPage } from "../pages/ambassador/dashboard/withdrawals/page";
import { CouponsPage } from "../pages/ambassador/dashboard/coupons/page";
import { LoginAmbPage } from "../pages/ambassador/auth/login/page";
import { AuthAmbLayout } from "../pages/ambassador/auth/layout";
import { AuthAmbGuard } from "./guards/auth-amb";
import { AuthAdmLayout } from "../pages/admin/auth/layout";
import { LoginAdmPage } from "../pages/admin/auth/login/page";
import { AuthAdmGuard } from "./guards/auth-adm";
import { RateAdminPage } from "../pages/admin/dashboard/rate/page";
import { DashboardLayoutAdm } from "../pages/admin/dashboard/layout";
import { CouponAdminPage } from "../pages/admin/dashboard/coupon/page";
import { WithdrawAdminPage } from "../pages/admin/dashboard/withdrawal/page";
import { ReferencesAdminPage } from "../pages/admin/dashboard/reference/page";
import { OverviewAdPage } from "../pages/admin/dashboard/overview/page";
import { ResumeAdminPage } from "../pages/admin/dashboard/resume/page";
import { BonusAdminPage } from "../pages/admin/dashboard/bonus/page";
import { UserAdminPage } from "../pages/admin/dashboard/client/page";
import { AmbaAdminPage } from "../pages/admin/dashboard/ambassador/page";
import { AdminAdminPage } from "../pages/admin/dashboard/admin/page";
import { PaymentAdminPage } from "../pages/admin/dashboard/payment/page";
import { DownloadAdminPage } from "../pages/admin/dashboard/download/page";
import { PaymentProviderPage } from "../pages/admin/dashboard/payment-provider/page";
import { NotFoundPage } from "../pages/public/not-found";
import { FeatureUnavailablePage } from "../pages/public/feature-unavailable";
import { PaymentReturnPage } from "../pages/client/builder/return-page-payment";
import {
  AiCreditsPage as UserSpaceAiCreditsPage,
  AmbassadorPage as UserSpaceAmbassadorPage,
  CoverLettersPage as UserSpaceCoverLettersPage,
  CoverLetterTemplatesPage as UserSpaceCoverLetterTemplatesPage,
  DashboardPage as UserSpaceDashboardPage,
  LoyaltyPage as UserSpaceLoyaltyPage,
  WalletPage as UserSpaceWalletPage,
  ReferralsPage as UserSpaceReferralsPage,
  ResumesPage as UserSpaceResumesPage,
  ResumeTemplatesPage as UserSpaceResumeTemplatesPage,
  UserSpaceLayout,
  UserSpaceSettingsPage,
} from "../pages/client/user-space";
import { RolePermissionAdminPage } from "../pages/admin/dashboard/role-permission/page";
import { InboxAdminPage } from "../pages/admin/dashboard/inbox/page";
import { HelpAdminPage } from "../pages/admin/dashboard/help/page";
import { CampaignsAdminPage } from "../pages/admin/dashboard/campaigns/page";
import { AuditAdminPage } from "../pages/admin/dashboard/audit/page";
import { ImportsAdminPage } from "../pages/admin/dashboard/imports/page";
export const routes = createRoutesFromElements(
  <Route element={<Providers />}>
    <Route errorElement={<ErrorPage />}>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Navigate replace to="/client/auth/login" />} />{" "}
        {/* element={<HomePage />} */}
      </Route>
      <Route path="client">
        <Route path="auth">
          <Route element={<AuthLayout />}>
            <Route element={<GuestGuard />}>
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<RegisterPage />} />
            </Route>

            {/* Password Recovery */}
            <Route element={<GuestGuard />}>
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />
            </Route>

            {/* Activation de compte provisionné (migration CSV → lien e-mail) */}
            <Route element={<GuestGuard />}>
              <Route path="activate" element={<ActivatePage />} />
            </Route>

            {/* Two-Factor Authentication */}
            <Route element={<GuestGuard />}>
              <Route path="verify-otp" element={<VerifyOtpPage />} />
              <Route path="backup-otp" element={<BackupOtpPage />} />
            </Route>

            {/* Email Verification */}
            <Route element={<AuthGuard />}>
              <Route path="verify-email" element={<VerifyEmailPage />} />
            </Route>

            {/* OAuth Callback */}
            <Route path="callback" loader={authLoader} element={<div />} />
          </Route>

          <Route index element={<Navigate replace to="/client/auth/login" />} />
        </Route>
        <Route path="user-space">
          <Route element={<AuthGuard />}>
            <Route element={<UserSpaceLayout />}>
              <Route index element={<UserSpaceDashboardPage />} />

              <Route path="resumes" element={<UserSpaceResumesPage />} />

              <Route path="cover-letters" element={<UserSpaceCoverLettersPage />} />
              <Route
                path="cover-letters/new"
                element={<Navigate replace to="/client/user-space/cover-letters" />}
              />

              <Route path="templates/resumes" element={<UserSpaceResumeTemplatesPage />} />

              <Route
                path="templates/cover-letters"
                element={<UserSpaceCoverLetterTemplatesPage />}
              />
              <Route path="referrals" element={<UserSpaceReferralsPage />} />
              <Route path="ambassador" element={<UserSpaceAmbassadorPage />} />
              <Route path="loyalty" element={<UserSpaceLoyaltyPage />} />
              <Route path="wallet" element={<UserSpaceWalletPage />} />
              <Route path="ai-credits" element={<UserSpaceAiCreditsPage />} />
              <Route path="settings" element={<UserSpaceSettingsPage />} />
              <Route path="notifications" element={<UserSpaceNotificationsPage />} />
              <Route path="notifications/:id" element={<UserSpaceNotificationDetailPage />} />
              <Route path="help" element={<UserSpaceHelpPage />} />
              <Route path="help/:id" element={<UserSpaceHelpRequestDetailPage />} />
              <Route path="*" element={<FeatureUnavailablePage />} />
            </Route>
          </Route>
        </Route>
        <Route path="dashboard">
          {/* Bascule user-space : l'ancien dashboard client est débranché —
              chaque route redirige vers son équivalent user-space. Les
              composants legacy restent disponibles en tant que librairie. */}
          <Route element={<AuthGuard />}>
            <Route index element={<Navigate replace to="/client/user-space/resumes" />} />
            <Route path="resumes" element={<Navigate replace to="/client/user-space/resumes" />} />
            <Route
              path="settings"
              element={<Navigate replace to="/client/user-space/settings" />}
            />
            <Route
              path="references"
              element={<Navigate replace to="/client/user-space/referrals" />}
            />
            <Route
              path="notifications"
              element={<Navigate replace to="/client/user-space/notifications" />}
            />
            <Route
              path="notifications/:id"
              element={<Navigate replace to="/client/user-space/notifications/:id" />}
            />
          </Route>
        </Route>
        <Route element={<AuthGuard />}>
          <Route path="payment-check/payment" element={<PaymentReturnPage />} />
        </Route>

        <Route path="builder">
          <Route element={<AuthGuard />}>
            <Route element={<BuilderLayout />}>
              <Route path=":id" loader={builderLoader} element={<BuilderPage />} />
              <Route index element={<Navigate replace to="/client/user-space/resumes" />} />
            </Route>
          </Route>
        </Route>

        <Route path="preview/*" element={<Navigate replace to="/client/user-space/resumes" />} />
      </Route>
      {/* Ambassador Routes */}
      {/* <Route path="ambassador">
        <Route path="auth">
          <Route element={<AuthAmbLayout />}>
            <Route path="login" element={<LoginAmbPage />} />
          </Route>
        </Route>
        <Route path="dashboard">
          <Route element={<AuthAmbGuard />}>
            <Route element={<DashboardLayoutAmb />}>
              <Route path="overview" element={<OverviewPage />} />
              <Route path="transactions" element={<TransactionsPage />} />
              <Route path="withdrawals" element={<WithdrawalsPage />} />
              <Route path="coupons" element={<CouponsPage />} />
              <Route index element={<Navigate replace to="/ambassador/dashboard/overview" />} />
            </Route>
          </Route>
        </Route>
      </Route> */}
      {/* Internal User/Admin Routes */}
      <Route path="admin">
        {/* /admin exact : redirige vers le tableau de bord admin (sinon leaf route vide = page blanche). */}
        <Route index element={<Navigate replace to="/admin/dashboard/overview" />} />
        <Route path="auth">
          <Route element={<AuthAdmLayout />}>
            {/* <Route element={<GuestGuard />}></Route> */}
            <Route path="login" element={<LoginAdmPage />} />
          </Route>
        </Route>
        <Route path="dashboard">
          <Route element={<AuthAdmGuard />}>
            <Route element={<DashboardLayoutAdm />}>
              <Route index element={<Navigate replace to="/admin/dashboard/overview" />} />
              <Route path="overview" element={<OverviewAdPage />} />
              {/* Boîte admin : alertes critiques (retraits, aide, paiements). */}
              <Route path="inbox" element={<InboxAdminPage />}></Route>
              {/* Centre d'aide : file d'attente des demandes clients. */}
              <Route path="help" element={<HelpAdminPage />}></Route>
              <Route path="campaigns" element={<CampaignsAdminPage />}></Route>
              <Route path="imports" element={<ImportsAdminPage />}></Route>
              <Route path="audit" element={<AuditAdminPage />}></Route>
              <Route path="rate" element={<RateAdminPage />} />
              <Route path="coupon" element={<CouponAdminPage />}></Route>
              <Route path="withdrawal" element={<WithdrawAdminPage />}></Route>
              <Route path="reference" element={<ReferencesAdminPage />}></Route>
              <Route path="resume" element={<ResumeAdminPage />}></Route>
              <Route path="bonus" element={<BonusAdminPage />}></Route>
              <Route path="client" element={<UserAdminPage />}></Route>
              <Route path="ambassador" element={<AmbaAdminPage />}></Route>
              <Route path="admin" element={<AdminAdminPage />}></Route>
              <Route path="transaction" element={<PaymentAdminPage />}></Route>
              <Route path="download" element={<DownloadAdminPage />}></Route>
              <Route path="payment-provider" element={<PaymentProviderPage />}></Route>
              <Route path="role-permission" element={<RolePermissionAdminPage />}></Route>
              {/*<Route path="rate" element ></Route>  */}
            </Route>
          </Route>
        </Route>
      </Route>

      {/* Public Routes */}

      {/* Désabonnement des e-mails de campagne (lien signé, sans authentification) */}
      <Route element={<AuthLayout />}>
        <Route path="unsubscribe" element={<UnsubscribePage />} />
      </Route>

      <Route path="feature-unavailable" element={<FeatureUnavailablePage />} />

      {/* 404 Not Found Catch-all Route */}
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Route>,
);

export const router = createBrowserRouter(routes);
